import ReactGA from 'react-ga4';
import { once, oncePromise, run } from '../helper/electron';
import { iTrack } from '../types/ITrack';
import isElectron from './isElectron';

interface ICloudCrateLink {
  name: string;
  link: string;
}

export const exportCsvUtil = async (
  title: string,
  trackList: iTrack[],
  hacker: string,
  cloudCrateLinks?: ICloudCrateLink[],
  selectedPath?: string,
): Promise<{ success: boolean; cancelled?: boolean; error?: string }> => {
  console.log('exporting csv');

  const headers = [
    '#',
    'Title',
    'Artist',
    'BPM',
    'Key',
    'Danceability',
    'Energy',
    'Mood',
  ];

  const metadataRows = [['', `${title} Hacked by: ${hacker}`], ['']];

  if (cloudCrateLinks && cloudCrateLinks.length > 0) {
    metadataRows.push(['', 'Cloud Crate Links:']);
    cloudCrateLinks.forEach((link) => {
      metadataRows.push(['', `${link.name.toUpperCase()}: ${link.link}`]);
    });
    metadataRows.push(['']);
  }

  const trackRows = trackList.map((track, index) => [
    `${index + 1}`,
    track.Title || '',
    track.Artist || '',
    track.BPM || '',
    track.Key_Camelot || '',
    track.danceability || '',
    track.energy || '',
    track.valence || '',
  ]);

  const rows = [...metadataRows, headers, ...trackRows];

  const csvString = rows.map((row) => row.join(',')).join('\n');

  if (isElectron()) {
    try {
      if (selectedPath) {
        const arrayBuffer = new TextEncoder().encode(csvString).buffer;
        run('save-file-array-buffer', {
          arrayBuffer: arrayBuffer,
          fileName: `${title}.csv`,
          seleteetedPath: selectedPath,
        });

        await new Promise<string>((resolve, reject) => {
          once('save-file-array-buffer', (response: string) => {
            if (!response) {
              reject(
                new Error('[save-file-array-buffer] returned empty response'),
              );
              return;
            }
            resolve(response);
          });
        });

        ReactGA.event({
          category: 'Export',
          action: 'CSV Export',
          label: title,
          value: 1, // successful
        });
        return { success: true };
      } else {
        run('save-file-dialog', {
          defaultPath: `${title.replace(/[^\w\s]/gi, '')}.csv`,
          content: csvString,
          filters: [{ name: 'CSV Files', extensions: ['csv'] }],
        });
        const response = await oncePromise('save-file-dialog-response');
        if (response?.success) {
          ReactGA.event({
            category: 'Export',
            action: 'CSV Export',
            label: title,
            value: 1, // successful
          });
        } else {
          ReactGA.event({
            category: 'Export',
            action: 'Export Crate',
            label: 'PDF',
            value: 0, // not successful
          });
        }
        return response;
      }
    } catch (error) {
      ReactGA.event({
        category: 'Export',
        action: 'Export Crate',
        label: 'PDF',
        value: 0, // not successful
      });
      return {
        success: false,
        error: error instanceof Error ? error.message : String(error),
      };
    }
  } else {
    try {
      const dataUri =
        'data:text/csv;charset=utf-8,' + encodeURIComponent(csvString);

      const link = document.createElement('a');
      link.href = dataUri;
      link.download = `${title.replace(/[^\w\s]/gi, '')}.csv`;

      link.click();

      ReactGA.event({
        category: 'Export',
        action: 'CSV Export',
        label: title,
        value: 1, // successful
      });
      return { success: true };
    } catch (error) {
      ReactGA.event({
        category: 'Export',
        action: 'Export Crate',
        label: 'PDF',
        value: 0, // not successful
      });
      return {
        success: false,
        error: error instanceof Error ? error.message : String(error),
      };
    }
  }
};
